import React, { useEffect } from 'react';

const Head = ({ 
  icon = 'default-icon-path',
  title = 'Default Title',
  image = 'default-image-path',
  description = 'Default description text.',
  tags = [],
  isIndex = false 
}) => {

  useEffect(() => {
    const pageTitle = title || 'Default Title';
    const pageDescription = description || 'Default description text.';
    const pageImage = image || '';
    const pageIcon = icon || 'default-icon-path';

    // Set page title if not already set
    if (document.title !== pageTitle) {
      document.title = pageTitle;
    }

    const setMetaTag = (selector, attr, content) => {
      const tag = document.querySelector(selector);
      if (tag && tag.getAttribute(attr) !== content) {
        tag.setAttribute(attr, content);
      }
    };

    // Check and update meta tags if necessary
    setMetaTag('meta[name="description"]', 'content', pageDescription);
    setMetaTag('meta[property="og:image"]', 'content', pageImage);
    setMetaTag('meta[property="og:title"]', 'content', pageTitle);
    setMetaTag('meta[property="og:description"]', 'content', pageDescription);
    setMetaTag('meta[name="twitter:title"]', 'content', pageTitle);
    setMetaTag('link[rel="icon"]', 'href', pageIcon);

    // Remove existing meta keywords tags to avoid duplicates
    const existingKeywordMetas = document.querySelectorAll('meta[name="keywords"]');
    existingKeywordMetas.forEach(meta => meta.parentNode.removeChild(meta));

    // Set robots meta tag based on isIndex prop
    const existingRobotsMeta = document.querySelector('meta[name="robots"]');
    const robotsContent = isIndex ? 'index, follow' : 'noindex, nofollow';
    if (existingRobotsMeta) {
      if (existingRobotsMeta.getAttribute('content') !== robotsContent) {
        existingRobotsMeta.setAttribute('content', robotsContent);
      }
    } else {
      const robotsMeta = document.createElement('meta');
      robotsMeta.name = 'robots';
      robotsMeta.content = robotsContent;
      document.head.appendChild(robotsMeta);
    }

    // Add or update keywords meta tag
    if (tags.length) {
      const existingKeywordsMeta = document.querySelector('meta[name="keywords"]');
      const keywordsContent = tags.join(', ');
      if (existingKeywordsMeta) {
        if (existingKeywordsMeta.getAttribute('content') !== keywordsContent) {
          existingKeywordsMeta.setAttribute('content', keywordsContent);
        }
      } else {
        const meta = document.createElement('meta');
        meta.name = "keywords";
        meta.content = keywordsContent;
        document.head.appendChild(meta);
      }
    }
  }, [title, description, image, tags, icon, isIndex]);

  return null;
};

export default Head;
